module.exports = __webpack_public_path__ + "img/american_express.45bc802e.svg";